/**
 * Route for `meta-conversions-api-capi-server-side-forwarding`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MetaConversionsApiCapiServerSideForwardingPage } from "../features/meta-conversions-api-capi-server-side-forwarding/MetaConversionsApiCapiServerSideForwardingPage";

export const metaConversionsApiCapiServerSideForwardingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/meta-conversions-api-capi-server-side-forwarding",
	component: MetaConversionsApiCapiServerSideForwardingPage,
});

export default metaConversionsApiCapiServerSideForwardingRoute;
